const faqItems = [
  {
    q: '911黑料网是什么？',
    a: '911黑料网是国内领先的娱乐八卦与热点爆料聚合平台，整合911黑料吃瓜网、911吃瓜黑料网等多个入口，提供最新、最全、最快的明星黑料、网红八卦、综艺内幕等资讯内容。所有爆料均经过编辑团队核实，确保信息真实可靠。',
  },
  {
    q: '如何快速找到911黑料网入口？',
    a: '您可以直接通过浏览器访问我们的官方网址，或关注微信公众号「911黑料网」获取入口直达链接。建议收藏本页面，随时随地快速访问不迷路。移动端用户可直接使用手机浏览器访问，无需下载APP。',
  },
  {
    q: '911黑料网的内容可信吗？',
    a: '我们坚持「真实、快速、深度」的内容理念。每一条爆料发布前均经过编辑团队多轮核实与交叉验证，拒绝谣言与假料。同时我们严格保护爆料人的隐私安全，所有投稿均采用匿名处理机制。',
  },
  {
    q: '如何向911黑料网投稿爆料？',
    a: '你可以通过页面「投稿爆料」区域提供的邮箱地址或微信公众号联系我们。我们接受文字、图片、音频、视频等多种形式的爆料材料。所有爆料人信息将严格保密，内容经核实后会以匿名方式发布。',
  },
  {
    q: '911黑料网更新频率如何？',
    a: '我们保持7×24小时全天候内容更新，平均每日发布超过50条独家或追踪报道。重大突发事件发生后，编辑团队会在30分钟内完成核实并发布第一手快讯，确保你永远比朋友圈先吃到瓜。',
  },
  {
    q: '911黑料网与其他吃瓜平台有什么不同？',
    a: '相比其他吃瓜平台，911黑料网拥有三大核心优势：第一，内容更新速度全网领先，平均比同类平台快2-4小时；第二，所有爆料均经过多方交叉核实，杜绝虚假信息；第三，隐私保护机制完善，爆料人身份信息绝对安全。我们是吃瓜，更是守护真相。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="font-heading font-bold text-foreground-900 text-sm md:text-base mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0">Q{idx + 1}.</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-5 md:pl-6">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}